jQuery(window).on('load', function () {
    checkAccordionItems();
    checkTraingModule();
    initModal();
});

jQuery(document).ready(function() {
    (function($) {
        var allPanels = $('#accordion > div');

        $('#accordion > h3').click(function() {
            allPanels.slideUp();

            if(!$(this).hasClass('active')) {
                $('#accordion > .active').removeClass('active');
                $(this).addClass('active');
                $(this).next().slideDown();
            } else {
                $(this).removeClass('active');
            }
        });

    })(jQuery);
});

jQuery('body').on('click', '.language-switch-button', function () {
    var container = jQuery(this).parents('.language-switcher');
    var dropdown = container.find('.language-switcher-dropdown');
    dropdown.toggleClass('hidden');
});

function checkAccordionItems() {
    var myRadios = document.getElementsByName('accordionItem');
    var setCheck;
    var x = 0;
    for(x = 0; x < myRadios.length; x++){
        myRadios[x].onclick = function(){
            if(setCheck != this){
                setCheck = this;
            }else{
                this.checked = false;
                setCheck = null;
            }
        };
    }
}

function checkTraingModule() {
    //Training logic
    var trainingPage = jQuery('.training-wk');
    if( trainingPage.length ){
        var trainingCode = trainingPage.data('uniquecode');
        var category = trainingPage.data('category');
        var currentAavailability = 0;
        var newActiveEl;
        var availability;
        var currentPage;

        jQuery('.date-item').click(function() {
            availability = jQuery(this).data('availability');
            currentPage = jQuery('#gform_source_page_number_11').val();
            newActiveEl = this;

            if (availability > 1) {
                jQuery('.gfield_list_icons').show();
            }

            if (currentAavailability > availability && availability > 0 && currentPage == 1) {
                jQuery('.wk-modal').removeClass('hidden');
                toggleModal();
            } else if(availability > 0 && currentPage == 1) {
                currentAavailability = availability;
                changeDate(newActiveEl, trainingCode, category, availability);
            }
        });

        jQuery('.confirm').click(function() {
            currentAavailability = availability;
            jQuery('#field_11_20 .gfield_list_group').not(':eq(0)').remove();
            changeDate(newActiveEl, trainingCode, category, availability);
            jQuery('.wk-modal').addClass('hidden');
            toggleModal();
        });
    }
}

function changeDate(el, trainingCode, category, availability) {
    jQuery(el).parents('nav').find('li.active').removeClass('active');
    jQuery(el).addClass('active');

    jQuery('.date-text').text(jQuery(el).data('date') + ' - ' + jQuery(el).data('time') + ' - ' + jQuery(el).data('place'));

    jQuery('#input_11_15').val(trainingCode);
    jQuery('#input_11_22').val(category);
    jQuery('#input_11_21').val(jQuery(el).data('code'));
    jQuery('#input_11_14').val(jQuery(el).data('place'));

    avilabilityUpdate(availability);
}

function avilabilityUpdate(availability) {
    jQuery('.add_list_item').attr('onclick', 'gformAddListItem(this,' + availability + ')');
    jQuery('.delete_list_item').attr('onclick', 'gformDeleteListItem(this,' + availability + ')');
    jQuery('.delete_list_item').attr('onkeypress', 'gformAddListItem(this,' + availability + ')');
    jQuery('.delete_list_item').attr('onkeypress', 'gformDeleteListItem(this,' + availability + ')');
}

function initModal() {
    jQuery('.wk-modal-overlay, .wk-modal-close').on('click', function (event) {
        event.preventDefault()
        toggleModal()
    });

    document.onkeydown = function(evt) {
        evt = evt || window.event
        var isEscape = false
        if ('key' in evt) {
            isEscape = (evt.key === 'Escape' || evt.key === 'Esc')
        } else {
            isEscape = (evt.keyCode === 27)
        }
        if (isEscape && document.body.classList.contains('modal-active')) {
            toggleModal()
        }
    };
}

function toggleModal () {
    var body = jQuery('body');
    var modal = jQuery('.wk-modal');
    modal.toggleClass('opacity-0');
    modal.toggleClass('pointer-events-none');
    body.toggleClass('modal-active');
}



// WEBPACK FOOTER //
// ./scripts/main.js